import { AxiosError } from 'axios';
import { createValidator, required, tip, TipLevels } from '@unitedtraders/validators';
import { restErrorsToForm } from '@unitedtraders/microfrontend-common';
import { Instrument } from '../../../hooks/mapInstruments';
import { useWithdrawService } from '../../../hooks/useWithdrawService';
import { isMultiple, validAccountNumber } from '../../../utils/validators';
import { useAmountValidators } from '../../../components/AmountInput/hooks';
import { FormValues } from '.';

// t('validator:incorrect alfa bank account number')
// t('toAlfaBank:Min {{min, money}} Amount must be multiple of {{factor}}')

const FACTOR = 500;

export const useFormProps = (instrument: Instrument) => {
  const withsrawService = useWithdrawService();
  const amountValidators = useAmountValidators(instrument);

  const validate = createValidator<FormValues>({
    amount: [...amountValidators, isMultiple(500)],
    accountNumber: [required(), validAccountNumber('validator:incorrect alfa bank account number')],
  });

  const validateTips = createValidator<FormValues>({
    amount: [
      tip(
        'toAlfaBank:Min {{min, money}} Amount must be multiple of {{factor}}',
        { min: instrument.minimum, factor: FACTOR },
        TipLevels.TIP
      ),
    ],
  });

  return {
    validate,
    validateTips,
    onSubmit: async (values: FormValues) => {
      try {
        await withsrawService.prepareAlfaBankAccountWithdraw(
          { value: values.amount, currency: instrument.currency },
          values.accountNumber.replace(/[^\d]/g, '')
        );
        return;
      } catch (e: AxiosError | any) {
        return restErrorsToForm(e.response?.data || e);
      }
    },
  };
};
